module.exports = __webpack_public_path__ + "img/advantage-3.fe8c1a34.png";